import { savedOrderDetailsOrderInformationStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import { checkoutBlockTitleStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

Object.assign(savedOrderDetailsOrderInformationStyles, {
    orderDateTitle: {
        variant: "h3",
        css: css`
            ${checkoutBlockTitleStyles()}
            margin-bottom: 8px;
        `,
    },
    orderDateText: {
        css: css`
            font-size: ${TYPOGRAPHY.size.small};
            color: ${COLORS.text.dark};
            line-height: 1.4;
        `,
    },
    shippingAddressTitle: {
        variant: "h3",
        css: css`
            ${checkoutBlockTitleStyles()}
            margin-bottom: 8px;
        `,
    },
    billingAddressTitle: {
        variant: "h3",
        css: css`
            ${checkoutBlockTitleStyles()}
            margin-bottom: 8px;
        `,
    },
});
